import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import imgArtist50Centfrom from "shared/assets/images/anno-domini-50cent-min.png";
import imgArtistSnoopDog from "shared/assets/images/anno-domini-snoopdog-min.png";
import imgArtistLilWayne from "shared/assets/images/anno-domini-lilwayne-min.png";
import imgArtistRickRoss from "shared/assets/images/anno-domini-rickross-min.png";
import imgArtistWuTang from "shared/assets/images/anno-domini-wutang-min.png";
import imgAnnoDominiLogoWeb from "shared/assets/images/anno-domini-logo.png";
import imgAnnoDominiMobile from "shared/assets/images/anno-domini-logo.png";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { SpecialCampaignEnum } from "shared/enums/SpecialCampaignEnum";
import {
  artistOriginSpecialCampaign,
  findSpecialCampaign,
  getSpecialCampaign,
  removeSessionSpecialCampaign,
} from "shared/helpers/special-campaign-helpers";
import { ClientSpecialCampaignApprovalEnum } from "shared/enums/ClientSpecialCampaignApprovalEnum";
import { postSpecialCampaignRequest } from "shared/service/StrmService";
import { toast } from "react-toastify";
import Modais from "shared/components/modais";
import "./CTACampanhasEspeciais.scss";
import { dataLayerDialogViewedEvent } from "event-tracker/gtm-events";
import { HomeDialogEventName } from "event-tracker/dialog-event-name";
import { getSpecialCampaignEventParams } from "event-tracker/special-campaign-events";

const MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24;

interface CTAEspecialProps {
  mobile?: boolean;
}

const CardCTAAnnoDomini: React.FC<CTAEspecialProps> = (props) => {
  const { mobile } = props;
  const { t } = useTranslation();
  const [isSpecialCampaignRequestSent, setIsSpecialCampaignRequestSent] =
    useState(false);
  const [openModalNotElegible, setOpenModalNotElegible] =
    useState<boolean>(false);
  const [openModalRequest, setOpenModalRequest] = useState<boolean>(false);
  const [openModalResultRequest, setOpenModalResultRequest] =
    useState<boolean>(false);
  const userCampaignOrigin = artistOriginSpecialCampaign(
    SpecialCampaignEnum.AnnoDomini
  );
  const { userArtist } = useSelector((state: any) => state.artists);

  const specialCampaign = getSpecialCampaign(
    userArtist?.specialCampaign,
    SpecialCampaignEnum.AnnoDomini
  );

  const elapsedDaysApproval = specialCampaign?.approvalOn
    ? Math.floor(
        (new Date().getTime() -
          new Date(specialCampaign.approvalOn).getTime()) /
          MILLISECONDS_PER_DAY
      )
    : 0;

  const campanhaEspecialAnnoDomini = findSpecialCampaign(
    userArtist?.specialCampaign,
    SpecialCampaignEnum.AnnoDomini
  );

  useEffect(() => {
    setOpenModalResultRequest(specialCampaign?.shouldNotifyArtist);
  }, [specialCampaign]);

  useEffect(() => {
    if (specialCampaign?.specialCampaignRequestId) {
      setIsSpecialCampaignRequestSent(true);
    }
  }, [specialCampaign]);

  useEffect(() => {
    if (userCampaignOrigin && !campanhaEspecialAnnoDomini)
      setOpenModalNotElegible(true);
  }, [campanhaEspecialAnnoDomini, userCampaignOrigin]);

  const onClickIniciaProcesso = async () => {
    if (
      !isSpecialCampaignRequestSent &&
      specialCampaign?.approval ===
        ClientSpecialCampaignApprovalEnum.NotRequested
    ) {
      dataLayerDialogViewedEvent(
        HomeDialogEventName.SPECIAL_CAMPAIGN_ELEGIBLE_SUBMITION,
        getSpecialCampaignEventParams(SpecialCampaignEnum.AnnoDomini)
      );
      const response: any = await postSpecialCampaignRequest({
        specialCampaign: SpecialCampaignEnum.AnnoDomini,
      });
      if (response?.response?.success) {
        setIsSpecialCampaignRequestSent(true);
        setOpenModalRequest(true);
        return;
      } else {
        toast.error<string>(
          t("pages.CampanhasEspeciais.AnnoDomini.erroAoSolicitar")
        );
        return;
      }
    }

    if (
      specialCampaign?.approval === ClientSpecialCampaignApprovalEnum.Approved
    ) {
      setOpenModalResultRequest(true);
      return;
    }

    if (
      specialCampaign?.approval === ClientSpecialCampaignApprovalEnum.Pending
    ) {
      setOpenModalRequest(true);
      return;
    }

    if (isSpecialCampaignRequestSent) {
      setOpenModalRequest(true);
      return;
    }
  };

  const ModaisRender = () => (
    <>
      <Modais.ModalCampaignADNotEligible
        open={openModalNotElegible}
        onCancel={() => {
          removeSessionSpecialCampaign(SpecialCampaignEnum.AnnoDomini);
          setOpenModalNotElegible(false);
        }}
      />
      <Modais.ModalCampaignADRequest
        open={openModalRequest}
        onCancel={() => setOpenModalRequest(false)}
      />
      <Modais.ModalCampaignADResponse
        open={openModalResultRequest}
        onCancel={() => setOpenModalResultRequest(false)}
      />
    </>
  );

  const title = () => {
    if (specialCampaign?.isParticipating) {
      return t("pages.CampanhasEspeciais.AnnoDomini.parabensSeloTitulo");
    }

    if (
      specialCampaign?.approval === ClientSpecialCampaignApprovalEnum.Pending
    ) {
      return t(
        "pages.CampanhasEspeciais.AnnoDomini.recebemosSolicitacaoSeloTitulo"
      );
    }

    if (
      specialCampaign?.approval === ClientSpecialCampaignApprovalEnum.Approved
    ) {
      return t("pages.CampanhasEspeciais.AnnoDomini.aprovadoSeloTitulo");
    }

    if (
      specialCampaign?.approval ===
      ClientSpecialCampaignApprovalEnum.Disapproved
    ) {
      return t("pages.CampanhasEspeciais.AnnoDomini.reprovadoSeloTitulo");
    }

    return t("pages.CampanhasEspeciais.AnnoDomini.facaParteSeloTitulo");
  };

  const text = () => {
    if (specialCampaign?.isParticipating) {
      return t("pages.CampanhasEspeciais.AnnoDomini.parabensSeloTexto");
    }

    if (
      specialCampaign?.approval === ClientSpecialCampaignApprovalEnum.Pending
    ) {
      return t(
        "pages.CampanhasEspeciais.AnnoDomini.recebemosSolicitacaoSeloTexto"
      );
    }

    if (
      specialCampaign?.approval ===
        ClientSpecialCampaignApprovalEnum.Approved ||
      specialCampaign?.approval ===
        ClientSpecialCampaignApprovalEnum.Disapproved
    ) {
      return t("pages.CampanhasEspeciais.AnnoDomini.moreDetails");
    }

    return t("pages.CampanhasEspeciais.AnnoDomini.facaParteSeloTexto");
  };

  const Content = () => (
    <div className="content anno-domini">
      <h1>{title()}</h1>
      <p>{text()}</p>
      {!specialCampaign?.isParticipating && (
        <div className="botoes">
          <button className="botao-roxo" onClick={onClickIniciaProcesso}>
            {!isSpecialCampaignRequestSent
              ? t("pages.CampanhasEspeciais.AnnoDomini.queroFazerParte")
              : t("pages.CampanhasEspeciais.AnnoDomini.saibaMais")}
          </button>
          <button
            className="botao-borda-roxa"
            hidden={
              specialCampaign?.approval ===
                ClientSpecialCampaignApprovalEnum.Approved ||
              specialCampaign?.approval ===
                ClientSpecialCampaignApprovalEnum.Disapproved
            }
          >
            <a
              href="https://annodomini.strmmusic.ai/"
              target="_blank"
              rel="noreferrer"
            >
              {t("pages.CampanhasEspeciais.AnnoDomini.irParaSiteDoSelo")}
            </a>
          </button>
        </div>
      )}
    </div>
  );

  if (!specialCampaign) return <ModaisRender />;

  if (
    elapsedDaysApproval > 5 &&
    specialCampaign?.approval === ClientSpecialCampaignApprovalEnum.Disapproved
  ) {
    return null;
  }

  if (mobile && isMobile && (userCampaignOrigin || specialCampaign?.approval)) {
    return (
      <div className="cta-campanha-especial anno-domini mobile">
        <ModaisRender />
        <img src={imgAnnoDominiMobile} alt="Anno Domini" className="image" />
        <div className="artists-container mobile">
          <div className="artists-container-title mobile">
            <p>
              {t(
                "pages.CampanhasEspeciais.AnnoDomini.beatsFromLegendaryArtists"
              )}
            </p>
          </div>
          <div className="artists-images">
            <div
              className="artist-image"
              style={{
                backgroundImage: `linear-gradient(180deg,rgba(18, 18, 18, 0) 68.68%,#080716 103.71%),url(${imgArtist50Centfrom})`,
              }}
            >
              <p>50 Cent</p>
            </div>
            <div
              className="artist-image"
              style={{
                backgroundImage: `linear-gradient(180deg,rgba(18, 18, 18, 0) 68.68%,#080716 103.71%),url(${imgArtistSnoopDog})`,
              }}
            >
              <p>Snoop Dogg</p>
            </div>
            <div
              className="artist-image"
              style={{
                backgroundImage: `linear-gradient(180deg,rgba(18, 18, 18, 0) 68.68%,#080716 103.71%),url(${imgArtistLilWayne})`,
              }}
            >
              <p>Lil Wayne</p>
            </div>
            <div
              className="artist-image"
              style={{
                backgroundImage: `linear-gradient(180deg,rgba(18, 18, 18, 0) 68.68%,#080716 103.71%),url(${imgArtistRickRoss})`,
              }}
            >
              <p>Rick Ross</p>
            </div>
            <div
              className="artist-image last mobile"
              style={{
                backgroundImage: `linear-gradient(180deg,rgba(18, 18, 18, 0) 68.68%,#080716 103.71%),url(${imgArtistWuTang})`,
              }}
            >
              <p>Wu Tang</p>
            </div>
          </div>
        </div>
        {Content()}
      </div>
    );
  } else if (
    !mobile &&
    !isMobile &&
    (userCampaignOrigin || specialCampaign?.approval)
  ) {
    return (
      <div className="cta-campanha-especial anno-domini web">
        <ModaisRender />
        {Content()}

        <img src={imgAnnoDominiLogoWeb} alt="Anno Domini" className="image" />

        <div className="artists-container">
          <div className="artists-container-title">
            <p>
              {t(
                "pages.CampanhasEspeciais.AnnoDomini.beatsFromLegendaryArtists"
              )}
            </p>
          </div>
          <div className="artists-images">
            <div
              className="artist-image"
              style={{
                backgroundImage: `linear-gradient(180deg,rgba(18, 18, 18, 0) 68.68%,#080716 103.71%),url(${imgArtist50Centfrom})`,
              }}
            >
              <p>50 Cent</p>
            </div>
            <div
              className="artist-image"
              style={{
                backgroundImage: `linear-gradient(180deg,rgba(18, 18, 18, 0) 68.68%,#080716 103.71%),url(${imgArtistSnoopDog})`,
              }}
            >
              <p>Snoop Dogg</p>
            </div>
            <div
              className="artist-image"
              style={{
                backgroundImage: `linear-gradient(180deg,rgba(18, 18, 18, 0) 68.68%,#080716 103.71%),url(${imgArtistLilWayne})`,
              }}
            >
              <p>Lil Wayne</p>
            </div>
            <div
              className="artist-image"
              style={{
                backgroundImage: `linear-gradient(180deg,rgba(18, 18, 18, 0) 68.68%,#080716 103.71%),url(${imgArtistRickRoss})`,
              }}
            >
              <p>Rick Ross</p>
            </div>
            <div
              className="artist-image last"
              style={{
                backgroundImage: `linear-gradient(180deg,rgba(18, 18, 18, 0) 68.68%,#080716 103.71%),url(${imgArtistWuTang})`,
              }}
            >
              <p>Wu Tang</p>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default CardCTAAnnoDomini;
